import MeasuringLength from "../../components/ClassOne/Mathematics/MeasuringLength";
import MeasuringLiquid from "../../components/ClassOne/Mathematics/MeasuringLiquid";
import MeasuringWeight from "../../components/ClassOne/Mathematics/MeasuringWeight";

// Define the type for menu items
interface MenuItem {
    url: string;
    title: string;
    component?: React.FC; // Optional React functional component
    subMenu?: MenuItem[]; // Allow subMenu to be an array of MenuItem
}


const topics: MenuItem[] = [
    { url: "/class-one/mathematics/measurement/measuring-length", title: "Measuring Length", component: MeasuringLength },
    { url: "/class-one/mathematics/measurement/measuring-weight", title: "Measuring Weight", component: MeasuringWeight },
    { url: "/class-one/mathematics/measurement/measuring-liquid", title: "Measuring Liquid", component: MeasuringLiquid },
];

export default topics;